// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Helpers
import parse from "html-react-parser";
import { Decimal } from "decimal.js";
// i18n
import { withNamespaces } from "react-i18next";
// Ducks
import { navigateTo } from "../Dashboard.ducks";
import { resetBookingState, scheduleBooking, initPayment } from "./ExamDetails.ducks";
import { fetchAppFeatureSettings } from "../../../services/clientSettings.ducks";
// Styles
import styles from "./ExamDetails.css";
// Components
import Modal from "../../../components/Modal";
import VoucherOverlay from "./components/VoucherOverlay";
import { localeCurrencyFormatter } from "../../../services/helper";

class ExamDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmationModal: false,
      overlayOpen: false,
      hasActiveVoucherSystem: true,
      hasActivePayment: false,
      isPaymentError: false,
      isPaymentErrorMessage: "",
      isPaymentErrorMessageInfo: ""
    };
  }

  async UNSAFE_componentWillMount() {
    const { data, navigateTo, resetBookingState } = this.props;

    resetBookingState();

    if (Object.keys(data).length === 0 && data.constructor === Object) {
      navigateTo(`/dashboard`);
    }

    const { fetchAppFeatureSettings } = this.props;
    const appFeatureSettings = await fetchAppFeatureSettings();

    this.setState({
      hasActiveVoucherSystem: appFeatureSettings.hasActiveVoucherSystem,
      hasActivePayment: appFeatureSettings.hasActivePayment
    });
  }

  componentDidMount() {
    document.addEventListener(`keydown`, this.onEscape);
  }

  componentWillUnmount() {
    document.removeEventListener(`keydown`, this.onEscape);
  }

  getSelectedPartsTotalPrice = () => {
    const { data } = this.props;

    return data.examinationParts.reduce(
      (acc, curr) => Decimal.add(acc, curr.examPrice).toNumber(),
      0
    );
  };

  getSelectedPartsTotalPriceForPayment = () => {
    const value = this.getSelectedPartsTotalPrice();

    //return value * 100;

    return value;
  };

  handleNewBooking = () => {
    const { hasActivePayment, hasActiveVoucherSystem } = this.state;

    if (this.isExamFree() || (!hasActivePayment && !hasActiveVoucherSystem && !this.isExamFree())) {
      this.toggleConfirmationModal();
    }
  };

  handleNewBookingPayment = async () => {
    const { hasActivePayment } = this.state;
    const { auth: { role }, users: { selectedCandidate }, data, initPayment, t } = this.props;

    const isAdmin = role === "admin";

    if (hasActivePayment) {
      this.setState({ overlayOpen: false });

      const initData = await initPayment({
        locale: data.locale,
        currency: data.currency,
        value: this.getSelectedPartsTotalPriceForPayment(),
        examPartsId: data.examinationParts.map((part) => Number(part.examPartId)),
        examinationDataId: Number(data.examinationDataId),
        candidateId: isAdmin ? selectedCandidate.id : null
      });

      if (initData && initData.success) {
        // const { missingExamParts, scheduleBooking } = this.props;

        // const examPartsId = data.examinationParts.map((part) => Number(part.examPartId));

        // scheduleBooking({
        //   examinationParts: examPartsId,
        //   examinationDataId: Number(data.examinationDataId),
        //   missingExamParts: Boolean(missingExamParts && missingExamParts.licenceId),
        //   voucherCodes: []
        // });

        const { paY_REQUEST_ID, checksum } = initData.resultContext.additionalData;

        const redirectHTML =
          `<html><body><form action="${
            initData.resultContext.redirectUrl
          }" method="POST" name="paymentForm" >` +
          `<input type="hidden" name="PAY_REQUEST_ID" value="${paY_REQUEST_ID}"> ` +
          `<input type="hidden" name="CHECKSUM" value="${checksum}"> ` +
          `</form>` +
          `<script type="text/javascript"> document.paymentForm.submit(); </script>` +
          `</body></html>`;

        document.write(redirectHTML);
      } else if (initData && initData.success === false) {
        this.setState({
          isPaymentError: true,
          isPaymentErrorMessage: initData.messageLocalizationKey,
          isPaymentErrorMessageInfo: initData.resultContext.detailedMessageInfo
        });
      }
    }
  };

  handleNewBookingVoucher = () => {
    const { hasActiveVoucherSystem } = this.state;
    if (hasActiveVoucherSystem) {
      this.setState({ overlayOpen: true });
    }
  };

  handleScheduleBooking = (values = {}) => {
    const { data, missingExamParts, scheduleBooking } = this.props;
    const { hasActivePayment, hasActiveVoucherSystem } = this.state;

    const examPartsId = data.examinationParts.map((part) => Number(part.examPartId));

    const vouchers = [];
    if (!this.isExamFree() && hasActiveVoucherSystem) {
      Object.keys(values).forEach((key) => {
        vouchers.push(values[key]);
      });
    }

    scheduleBooking({
      examinationParts: examPartsId,
      examinationDataId: Number(data.examinationDataId),
      missingExamParts: Boolean(missingExamParts && missingExamParts.licenceId),
      voucherCodes: vouchers
    });

    this.isExamFree() && this.toggleConfirmationModal();
  };

  isExamFree = () => !this.getSelectedPartsTotalPrice();

  onEscape = ({ keyCode }) => {
    const { confirmationModal, overlayOpen } = this.state;

    if (keyCode === 27) {
      (overlayOpen || confirmationModal) &&
        this.setState({ confirmationModal: false, overlayOpen: false });
    }
  };

  toggleConfirmationModal = () => {
    this.setState((prevState) => ({
      confirmationModal: !prevState.confirmationModal
    }));
  };

  toggleOverlay = () => {
    this.setState((prevState) => ({
      overlayOpen: !prevState.overlayOpen
    }));
  };

  render() {
    const { data, navigateTo, t } = this.props;
    const locationStreet = data.name ? ` - ${data.street}` : data.street;
    const {
      confirmationModal,
      overlayOpen,
      hasActivePayment,
      hasActiveVoucherSystem,
      isPaymentError,
      isPaymentErrorMessage,
      isPaymentErrorMessageInfo
    } = this.state;

    return !data.examinationParts ? null : (
      <div
        className="container"
        style={{
          marginTop: 50
        }}
      >
        <VoucherOverlay
          closeModal={this.toggleOverlay}
          isOpen={overlayOpen}
          onRequestClose={() => this.setState({ overlayOpen: false })}
          onSubmit={this.handleScheduleBooking}
          title={t(`modules.localization.register.authenticated.vouchers.insertVoucher`)}
          examinationParts={data.examinationParts}
          currency={data.currency}
        />

        <Modal
          cancelActionLabel={t(`modules.localization.register.generals.button.cancel`)}
          closeModal={this.toggleConfirmationModal}
          confirmAction={this.handleScheduleBooking}
          confirmActionLabel={t(`modules.localization.register.authenticated.exams.confirm`)}
          isOpen={confirmationModal}
          title={t(`modules.localization.register.authenticated.exams.bookNow`)}
        >
          <p>{t(`modules.localization.register.authenticated.exams.bookFreeExam`)}</p>
        </Modal>
        <div className="col-sm-12 well" style={styles.container}>
          <div style={styles.title}>{data.name}</div>
          <div style={styles.city}>{data.city}</div>
          <div style={styles.divider} />

          <table>
            <thead>
              <tr>
                <th>{t(`modules.localization.register.authenticated.exams.testName`)}</th>
                {data.totalPrice ? (
                  <th style={{ textAlign: `right` }}>
                    {t(`modules.localization.register.authenticated.exams.testPrice`)}
                  </th>
                ) : (
                  <th />
                )}
                <th style={{ textAlign: `right` }}>
                  {t(`modules.localization.register.authenticated.exams.testDuration`)}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.examinationParts.map((part) => (
                <tr key={part.examPartId}>
                  <td>{part.examName}</td>
                  <td style={{ textAlign: `right` }}>
                    {part.examPrice
                      ? localeCurrencyFormatter({
                          currency: data.currency,
                          locale: data.locale,
                          value: part.examPrice
                        })
                      : ``}
                  </td>
                  <td style={{ textAlign: `right` }}>
                    {`${part.examDuration} ${t(
                      `modules.localization.register.authenticated.exams.minutes`
                    )}`}
                  </td>
                </tr>
              ))}
            </tbody>
            {Boolean(this.getSelectedPartsTotalPrice()) && (
              <tfoot>
                <tr>
                  <td>
                    <b>{t(`modules.localization.register.authenticated.exams.totalPrice`)}</b>
                  </td>
                  <td style={{ textAlign: `right` }}>
                    <b>
                      {localeCurrencyFormatter({
                        locale: data.locale,
                        currency: data.currency,
                        value: this.getSelectedPartsTotalPrice()
                      })}
                    </b>
                  </td>
                  <td />
                </tr>
              </tfoot>
            )}
          </table>
          <div style={styles.divider} />
          <div style={styles.tabContent}>
            <p>
              <span style={styles.bold}>
                {t(`modules.localization.register.authenticated.exams.date`)}:{` `}
              </span>
              <span>{data.date}</span>
            </p>
            <p>
              <span style={styles.bold}>
                {t(`modules.localization.register.authenticated.exams.address`)}:{` `}
              </span>
              <span>{`${data.name} ${locationStreet}, ${data.postalCode} ${data.city}`}</span>
            </p>
            {data.email && (
              <p>
                <span style={styles.bold}>
                  {t(`modules.localization.register.authenticated.exams.email`)}:{` `}
                </span>
                <span>{data.email}</span>
              </p>
            )}
            {data.www && (
              <p>
                <span style={styles.bold}>WWW: </span>
                <span>{data.www}</span>
              </p>
            )}
          </div>
          {data.locationInformationText && (
            <>
              <div style={styles.divider} />
              <div>{parse(data.locationInformationText)}</div>
            </>
          )}
          <div style={styles.divider} />
          {Boolean(isPaymentError) && (
            <>
              <div className="alert alert-danger">
                {t(isPaymentErrorMessage, { error: isPaymentErrorMessageInfo })}
              </div>
              <div style={styles.divider} />
            </>
          )}
          <div style={styles.buttonContainer}>
            {Boolean(hasActivePayment) && Boolean(this.getSelectedPartsTotalPrice()) && (
              <button
                className="btn btn-success"
                onClick={this.handleNewBookingPayment}
                type="button"
                style={styles.buttonSecond}
              >
                {t(`modules.localization.register.authenticated.exams.finishReservation.payment`)}
              </button>
            )}
            {Boolean(hasActiveVoucherSystem) && Boolean(this.getSelectedPartsTotalPrice()) && (
              <button
                className="btn btn-success"
                onClick={this.handleNewBookingVoucher}
                type="button"
                style={styles.buttonSecond}
              >
                {t(`modules.localization.register.authenticated.exams.finishReservation.voucher`)}
              </button>
            )}
            {Boolean(!this.getSelectedPartsTotalPrice()) && (
              <button className="btn btn-success" onClick={this.handleNewBooking} type="button">
                {t(`modules.localization.register.authenticated.exams.finishReservation`)}
              </button>
            )}
            {Boolean(!hasActivePayment) &&
              Boolean(!hasActiveVoucherSystem) &&
              Boolean(this.getSelectedPartsTotalPrice()) && (
                <button className="btn btn-success" onClick={this.handleNewBooking} type="button">
                  {t(`modules.localization.register.authenticated.exams.finishReservation`)}
                </button>
              )}
            <button
              className="btn btn-secondary"
              onClick={() => {
                navigateTo(`/dashboard`);
              }}
              style={styles.buttonBack}
              type="button"
            >
              {t(`modules.localization.register.authenticated.exams.goBack`)}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ExamDetails.propTypes = {
  data: PropTypes.shape({
    city: PropTypes.string,
    currency: PropTypes.string,
    date: PropTypes.string,
    email: PropTypes.string,
    examinationParts: PropTypes.array,
    locale: PropTypes.string,
    locationInformationText: PropTypes.string,
    name: PropTypes.string,
    postalCode: PropTypes.string,
    www: PropTypes.string,
    examinationDataId: PropTypes.number
  }),
  missingExamParts: PropTypes.object,
  navigateTo: PropTypes.func.isRequired,
  resetBookingState: PropTypes.func.isRequired,
  scheduleBooking: PropTypes.func.isRequired,
  initPayment: PropTypes.func.isRequired,
  fetchAppFeatureSettings: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  data: state.exams.selectedDateObject,
  missingExamParts: state.exams.missingExamParts,
  auth: state.auth,
  users: state.users,
});

const mapDispatchToProps = {
  navigateTo,
  resetBookingState,
  scheduleBooking,
  initPayment,
  fetchAppFeatureSettings
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(ExamDetails);
